import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'app-max-test-rating',
  standalone: false,
  templateUrl: './max-test-rating.component.html',
  styleUrl: './max-test-rating.component.scss',
})
export class MaxTestRatingComponent {
  @Input({ required: true }) maxRating: number = null
  @Input({ required: false }) tooltip: string = null
  @Input() hoverAllRatingsUpToMax: boolean = false
  @Input() displayOn2Lines: boolean = false
  @Input() ratingOrder: {rating: 0|4|7|10, order: 1|2|3|4}[] = null
  @Input() isLoading: boolean = false

  @Output() onCliCkOnRatingEvent: EventEmitter<number> = new EventEmitter<number>()

  private hoveredRating: number = null

  public getTooltip(): string {
    return this.tooltip
  }

  public getAvailableRatings(): number[] {
    if (this.ratingOrder && this.ratingOrder.length === 4) {
      return this.ratingOrder
        .sort((a: any, b: any): number => a.order - b.order)
        .map(r => r.rating)
    }
    return [0, 4, 7, 10]
  }

  public isOneOfRatings(): boolean {
    return this.maxRating !== null && this.getAvailableRatings().includes(this.maxRating);
  }

  public onClickOnRating(rating: number): void {
    if (rating === this.maxRating || this.isLoading) {
      return
    }

    this.onCliCkOnRatingEvent.emit(rating)
  }

  public onRatingHover(rating: number): void {
    this.hoveredRating = rating
  }

  public onRatingLeave(): void {
    this.hoveredRating = null
  }

  public isColorActive(rating: number, color: 'red' | 'orange' | 'yellow' | 'green'): boolean {
    if (!this.hoverAllRatingsUpToMax) {
      return (this.maxRating === rating || this.hoveredRating === rating)
        && this.getColorByRating(rating) === color
    }

    return (
      (this.maxRating >= rating && this.isOneOfRatings())
        || (this.hoveredRating !== null && this.hoveredRating >= rating)
      )
      && this.getColorByRating(rating) === color
  }

  public getColorByRating(rating: number): 'red' | 'orange' | 'yellow' | 'green' {
    switch (rating) {
      case 0:
        return 'red'
      case 4:
        return 'orange'
      case 7:
        return 'yellow'
      case 10:
        return 'green'
      default:
        return null
    }
  }
}

